var _path, _path2, _path3, _path4, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCulture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53514 3.62587C9.95075 3.38592 10.4628 3.38592 10.8784 3.62587L14.7461 5.85887C15.1617 6.09882 15.4177 6.54228 15.4177 7.02219V11.4882C15.4177 11.9681 15.1617 12.4115 14.7461 12.6515L10.8784 14.8845C10.4628 15.1245 9.95075 15.1245 9.53514 14.8845L5.66748 12.6515C5.25186 12.4115 4.99583 11.9681 4.99583 11.4882V7.02219C4.99583 6.54228 5.25186 6.09882 5.66748 5.85887L9.53514 3.62587Z",
    fill: "url(#paint0_linear_202_1404)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1851 17.1631C10.5617 16.8032 9.79359 16.8032 9.17017 17.1631L1.00747 21.8759C0.384044 22.2358 0 22.901 0 23.6209V28.3038H20.3553V23.6209C20.3553 22.901 19.9712 22.2358 19.3478 21.8759L11.1851 17.1631Z",
    fill: "url(#paint1_linear_202_1404)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8408 3.62587C30.2564 3.38592 30.7685 3.38592 31.1841 3.62587L35.0518 5.85887C35.4674 6.09882 35.7234 6.54228 35.7234 7.02219V11.4882C35.7234 11.9681 35.4674 12.4115 35.0518 12.6515L31.1841 14.8845C30.7685 15.1245 30.2564 15.1245 29.8408 14.8845L25.9731 12.6515C25.5575 12.4115 25.3015 11.9681 25.3015 11.4882V7.02219C25.3015 6.54228 25.5575 6.09882 25.9731 5.85887L29.8408 3.62587Z",
    fill: "url(#paint2_linear_202_1404)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4905 17.1631C30.8671 16.8032 30.099 16.8032 29.4756 17.1631L21.3129 21.8759C20.6895 22.2358 20.3054 22.901 20.3054 23.6209V28.3038H40.6607V23.6209C40.6607 22.901 40.2767 22.2358 39.6532 21.8759L31.4905 17.1631Z",
    fill: "url(#paint3_linear_202_1404)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_202_1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6891 1.38808C20.1047 1.14812 20.6168 1.14812 21.0324 1.38808L25.8935 4.19464C26.3091 4.43459 26.5651 4.87805 26.5651 5.35796V10.9711C26.5651 11.451 26.3091 11.8944 25.8935 12.1344L21.0324 14.9409C20.6168 15.1809 20.1047 15.1809 19.6891 14.9409L14.828 12.1344C14.4124 11.8944 14.1564 11.451 14.1564 10.9711V5.35796C14.1564 4.87805 14.4124 4.43459 14.828 4.19464L19.6891 1.38808Z",
    fill: "url(#paint4_linear_202_1404)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3259 17.6257C20.7024 17.2658 19.9343 17.2658 19.3109 17.6257L9.20791 23.4587C8.58448 23.8186 8.20044 24.4838 8.20044 25.2037V30.9996H32.4363V25.2037C32.4363 24.4838 32.0523 23.8186 31.4289 23.4587L21.3259 17.6257Z",
    fill: "url(#paint5_linear_202_1404)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_202_1404",
    x: 7.52879,
    y: 0.536485,
    width: 26.9224,
    height: 32.478,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.671645,
    dy: 0.671645
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.671645
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_202_1404"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_202_1404",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_202_1404",
    x1: 10.2068,
    y1: 3.2381,
    x2: 10.2068,
    y2: 15.2723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_202_1404",
    x1: 10.1776,
    y1: 16.8932,
    x2: 10.1776,
    y2: 28.3038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_202_1404",
    x1: 30.5124,
    y1: 3.2381,
    x2: 30.5124,
    y2: 15.2723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_202_1404",
    x1: 30.4831,
    y1: 16.8932,
    x2: 30.4831,
    y2: 28.3038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_202_1404",
    x1: 27.525,
    y1: 1.00031,
    x2: 13.1965,
    y2: 1.00031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_202_1404",
    x1: 32.4363,
    y1: 17.3558,
    x2: 8.20044,
    y2: 17.3558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulture);
export default __webpack_public_path__ + "static/media/culture.5afc62bb05fc6ebcd0497e8d0e21fda1.svg";
export { ForwardRef as ReactComponent };